import Vue from 'vue'
import VModal from 'vue-js-modal'
import './components/BidButton'
import './components/BidDialog'
import './components/BidHistory'
import './components/BidHistoryWho'
import './components/Auctioneer'
import '../MonetizationDetail/components/MonetizationDocuments'
import axios from 'axios'
import {API_URL, DEFAULT_LANG_UUID} from '../utils/consts'
import i18n from '../plugins/i18n';
import moment from 'moment'
import '../utils/event'
import '../utils/autobahn'
import {makeInterval} from "../utils/countdown";
import {injectTokenInterceptor} from "../utils/tokenInterceptor";

import Toasted from 'vue-toasted'
import {ContentLoader} from 'vue-content-loader'
import {VueMaskDirective, VueMaskFilter} from 'v-mask'
import money from 'v-money'
import dateFilter from '../utils/dateFilter'
import {AuctionService} from './auction.service'
import {FakeAuctionService} from "./fake-auction.service"
import timezoneChecker from "../utils/timezoneChecker"
import {sleep} from "../utils/sleep"
import truncateFilter from "../utils/truncateFilter"

moment.locale('cs')

Vue.component('skeleton', ContentLoader)
Vue.use(VModal, {dynamic: true});
Vue.filter('lang', (value) => value && value[DEFAULT_LANG_UUID])
Vue.filter('VMask', VueMaskFilter)
Vue.filter('formatDate', dateFilter)
Vue.filter('truncate', truncateFilter)
Vue.directive('mask', VueMaskDirective);
Vue.use(money)
Vue.use(Toasted)

new Vue({
  i18n,
  el: '#auctionRoom',

  data() {
    return {
      supportsWebSockets: false,
      isTest: false,
      token: null,
      monetizationId: null,
      monetizationType: null,
      monetization: null,
      startCounterInterval: null,
      endCounterInterval: null,
      actualTimeInterval: null,
      isRunningTimeInterval: null,
      timeRemainingToStart: null,
      timeRemainingToEnd: null,
      timeRemainingToFinishPriceOffer: null,
      isAuctionRunning: false,
      auctionFinished: true,
      actualTime: null,
      bid: null,
      accessAllowed: true,
      showJapaneseMonetizationActivity: true,
      money: {
        decimal: ',',
        thousands: ' ',
        precision: 0,
        masked: false,
        suffix: '',
      },
      isRunning: false,
      service: null,
      fetchMonetizationTimer: null,
      auctionRobot: {
        isActive: false,
        maxLimit: 0
      },
      isDifferentTimeZone: false,
      accountId: localStorage.getItem('accountId') || null,
      logCollapsed: {}
    }
  },

  created() {
    this.supportsWebSockets = 'WebSocket' in window || 'MozWebSocket' in window
    const {isDifferentTimeZone} = timezoneChecker()
    this.isDifferentTimeZone = isDifferentTimeZone
    this.init()
    this.setAccountId()
  },

  mounted() {
    if (this.isTest) {
      this.$modal.show({
        template: `
            <div id="test-auction-modal" class="alert" style="margin: 0; padding: 2rem 2rem;">
                <div class="popup-window__close popup-window-close" @click="$emit('close')"><span class="icon-close"></span></div>
                <h1>{{ title }}</h1>
                <p>{{ text }}</p>
                <div class="d-flex justify-content-between">
                  <button class="btn btn-primary" v-on:click="startTestAuction();$emit('close')">{{ startButton }}</button>
                  <button class="btn btn-light" v-on:click="cancelTestAuction()">{{ cancelButton }}</button>
                </div>
            </div>`,
        props: ['title', 'text', 'startButton', 'cancelButton', 'startTestAuction', 'cancelTestAuction']
      }, {
        title: this.$i18n.t('auctionRoom.monetization.test.modal.title'),
        text: this.$i18n.t('auctionRoom.monetization.test.modal.text'),
        startButton: this.$i18n.t('auctionRoom.monetization.test.modal.button.ok'),
        cancelButton: this.$i18n.t('auctionRoom.monetization.test.modal.button.cancel'),
        startTestAuction: () => {
          const el = document.querySelector('#test-auction-modal')
          if (el) {
            el.style.display = 'none'
          }
          const modalOverlay = document.querySelector('.v--modal-overlay')
          if (modalOverlay) {
            modalOverlay.style.display = 'none'
          }
          this.init()
        },
        cancelTestAuction: () => location.replace('/')
      }, {
        height: 'auto',
        width: 700,
        adaptive: true,
        clickToClose: false
      })
    }
  },

  destroyed() {
    this.clearIntervals()
    this.init()
  },

  computed: {
    currency() {
      if (this.monetization) {
        return this.monetization.info && this.monetization.info.currency && this.monetization.info.currency.symbol || ''
      }
      return null
    },
    iamWinner() {
      return this.accountId === this.monetization.info?.currentWinner?.contact?.id
    }
  },

  methods: {
    init() {
      const translateEl = document.getElementById('translates')
      this.$i18n.setLocaleMessage('cs', JSON.parse(translateEl.innerHTML))

      const el = document.getElementById('monetizationDetail')
      const {id, type, isTest} = JSON.parse(el.innerHTML)
      this.isTest = isTest
      this.service = this.isTest ? FakeAuctionService : AuctionService
      if (!this.isTest) {
        this.token = injectTokenInterceptor(this.$toasted)
      }

      if (this.isTest) {
        localStorage.removeItem('testAuction')
      }

      Event.listen('refreshMonetization', () => this.fetchMonetization());
      this.monetizationId = id
      this.monetizationType = type
      this.fetchMonetization()

      if (!this.isTest) {
        this.connectToWS(this.token)
      }

      this.setMonetizationTimer()
      this.loadAuctionRobotFromLocalStorage()
    },

    setMonetizationTimer() {
      clearInterval(this.fetchMonetizationTimer)
      this.fetchMonetizationTimer = setInterval(() => this.fetchMonetization(), 30000)
    },

    clearIntervals() {
      clearInterval(this.startCounterInterval)
      clearInterval(this.endCounterInterval)
      clearInterval(this.finishPriceOfferCounterInterval)
      clearInterval(this.actualTimeInterval)
      clearInterval(this.isRunningTimeInterval)
    },

    countdownAuctionStart() {
      if (this.monetization && this.monetization.info && this.monetization.info.start && this.monetization.info.start.date) {
        clearInterval(this.startCounterInterval)
        this.startCounterInterval = makeInterval(this.monetization.info.start.date, remaining => {
          if (remaining) {
            this.isAuctionRunning = false
            this.timeRemainingToStart = remaining
          } else {
            this.isAuctionRunning = true
            this.timeRemainingToStart = null
            clearInterval(this.startCounterInterval)
          }
        })
      }
    },

    countdownFinishPriceOffer() {
      if (this.monetization && this.monetization.info && this.monetization.info.finishPriceOffer) {
        clearInterval(this.finishPriceOfferCounterInterval)
        this.finishPriceOfferCounterInterval = makeInterval(this.monetization.info.finishPriceOffer, remaining => {
          if (remaining) {
            this.timeRemainingToFinishPriceOffer = remaining
          } else {
            this.timeRemainingToFinishPriceOffer = this.$i18n.t(`auctionRoom.${this.monetization.type}.priceOfferIsFinished`)
            clearInterval(this.finishPriceOfferCounterInterval)
          }
        })
      }
    },

    countdownAuctionFinish() {
      if (!this.monetization.info.finished) {
        clearInterval(this.endCounterInterval)
        if (this.monetization && this.monetization.info && this.monetization.info.finish && this.monetization.info.finish.date) {
          this.endCounterInterval = makeInterval(this.monetization.info.finish.date, remaining => {
            if (remaining) {
              this.timeRemainingToEnd = remaining
              this.auctionFinished = false
            } else {
              this.timeRemainingToEnd = this.$i18n.t(`auctionRoom.${this.monetization.type}.IsEnd`)
              this.auctionFinished = true
              clearInterval(this.endCounterInterval)
            }
          })
        }
      }
    },

    checkIsRunning() {
      clearInterval(this.isRunningTimeInterval)
      this.isRunningTimeInterval = setInterval(() => {
        if (this.monetization ?.info ?.finish ?.date && this.monetization ?.info ?.start ?.date) {
          const now = moment()
          if (now.isAfter(moment(this.monetization ?.info ?.start ?.date)) && now.isBefore(moment(this.monetization ?.info ?.finish ?.date))) {
            this.isRunning = true
          } else {
            this.isRunning = false
          }
        }
      }, 1000)
    },

    async fetchMonetization(monetization) {
      try {
        this.clearIntervals()

        try {
          if (monetization) {
            this.monetization = {...monetization}
          } else {
            this.monetization = await this.service.fetchMonetization(this.monetizationId)
          }
          this.bid = this.monetization && this.monetization.info && this.monetization.info.minimumBid || 0
          this.countdownAuctionStart()
          this.countdownAuctionFinish()
          this.countdownFinishPriceOffer()
          this.checkIsRunning()
          this.actualTimeInterval = setInterval(() => this.actualTime = moment().format('HH:mm:ss'), 1000)
          this.accessAllowed = true

          if (this.monetization.mode === 'japanese') {
            this.showJapaneseMonetizationActivity = this.monetization.info.cycle >= 2 && !!this.monetization.info.lastOffer?.date
          }
          if (this.monetization.mode === 'english' && this.auctionRobot && this.auctionRobot.isActive && ((this.monetization.info.currentWinner && !this.monetization.info.currentWinner.iam) || !this.monetization.info.currentWinner) && this.isRunning) {
            this.makeBid()
          }

          this.setMonetizationTimer()
          this.setMoneyCurrency()
        } catch (e) {
          console.error(e)
          if (e.response.code === 403) {
            this.$toasted.show(this.$i18n.t('auctionRoom.error.noAccess'), {type: 'error'})
            this.accessAllowed = false
          }
        }
      } catch (e) {
        console.error(e)
        if (e.response.code === 403) {
          this.$toasted.show(this.$i18n.t('auctionRoom.error.noAccess'), {type: 'error'})
          this.accessAllowed = false
        }
      }
    },

    async connectToWS(token) {
      const {data: {webSocketUrl}} = await axios.get(`${API_URL}/core`, {headers: {'content-type': 'application/json'}})

      try {
        console.info('WebSocket connecting...')
        const conn = new ab.Session(`${webSocketUrl}/?token=${token}`,
          async () => {
            console.info('WebSocket connection established')
            this.heartbeat(conn)
            conn.subscribe(`monetization_${this.monetizationId}`, (topic, data) => {
              console.info('ws:notifications', data);
              if (data) {
                this.fetchMonetization(data)
              }
            });
          },
          () => {
            console.warn('WebSocket connection closed');
            try {
            } catch (e) {}
            this.connectToWS(this.token)
          },
          {skipSubprotocolCheck: true}
        );
      } catch (e) {
        console.error(e)
      }
    },

    heartbeat(conn) {
      conn.publish("fake.topic", ['Hello, world!'])
      setTimeout(() => this.heartbeat(conn), 10000);
    },

    activateRobot() {
      this.auctionRobot.isActive = true
      this.saveAuctioRobotToLocalStorage()
      this.$toasted.show(this.$i18n.t('auctionRoom.auctionRobot.activated'), {type: 'success', position: 'top-center', duration: 5000})
      this.fetchMonetization()
    },

    deactivateRobot() {
      this.auctionRobot.isActive = false
      this.saveAuctioRobotToLocalStorage()
      this.$toasted.show(this.$i18n.t('auctionRoom.auctionRobot.deactivated'), {type: 'success', position: 'top-center', duration: 5000})
    },

    makeBid() {
      if (Number(this.monetization.info.minimumBid) <= Number(this.auctionRobot.maxLimit.replaceAll(this.money.suffix, '').replaceAll(' ', ''))) {
         Event.fire('submitBid', this.monetization.info.minimumBid)
      }
    },

    saveAuctioRobotToLocalStorage() {
      localStorage.setItem(`auctionRobot-${this.monetizationId}`, JSON.stringify(this.auctionRobot))
    },

    loadAuctionRobotFromLocalStorage() {
      const robot = JSON.parse(localStorage.getItem(`auctionRobot-${this.monetizationId}`))
      if (robot){
        this.auctionRobot = robot
      }
    },

    changeAuctionRobotLimit() {
      this.saveAuctioRobotToLocalStorage()
    },

    setMoneyCurrency() {
      this.money.suffix = ` ${this.currency}`
    },

    async setAccountId() {
      while (!this.accountId) {
        try {
          const response = await axios.get(`${API_URL}/account`, {headers: {'content-type': 'application/json'}})
          const account = response.data.record
          if (account) {
            this.accountId = account.id
            localStorage.setItem('accountId', account.id)
          }
        } catch (e) {
          console.error(e)
        }
        await sleep(2000)
      }
    },
    truncateLog(text) {
      return truncateFilter(text, 500, true)
    },
    logCollapse(log, val) {
      log['collapsed'] = val
      this.$forceUpdate()
    },
    slice(val, countChars) {
      return val ? val.slice(countChars) : val
    }
  }
});
